export interface Theme {
    name: string;
    properties: any;
    theme: any
}

export const defaultTheme: Theme = {
    name: "defaultTheme",
    theme: 'default',
    properties: {

        // Main, Scd and Third are usually for titles and texts.
        "--mainColor": "#5c4a7e",
        "--scdColor": "#4f3c74",
        "--thirdColor": "#34274d",

        "--textColor": "#5c4a7e",

        // onSurface is for the colors on the surface of the app: grey boxes, side bar etc.
        "--onSurface": "#efeef8",

        // Title Sections
        "--titleSection": "#fff",

        // Breadcrumbs
        "--breadcrumbs": "#ffeed6",

        // Highlighted Items
        "--highLight": "#ffeed6",
        "--highLightSideNav": "#fff",
        "--highLightLabelSideNav": "#ffeed6",
        "--textHoverLabelSideNav": "var(--thirdColor)",
        "--textLabelSideNav":"var(--thirdColor)",
        "--activeLabelSideNav":"#ffeed6",
        "--activeTextLabelSideNav":"var(--thirdColor)",

        // Buttons
        "--defaultBtn": "var(--mainColor)",
        "--hoverBtn": "#471a66",
        "--attachmentBtn":"#4f3c74",

        // Labels
        "--ovale": "#BCB7C8",
        "--textOvale":"#fff",
        "--label": "var(--highLight)",
        "--labelSideNav": "#fff",
        "--ovalePlanReview": "#2cbfb1",
        "--textLabel": "var(--thirdColor)",

        // Financial Bars
        "--financialFirstBar": "#98ABB6",
        "--financialScdBar": "var(--mainColor)",

        // SVGs
        // Global
        "--backgroundColorSVG": "var(--onSurface)",
        "--signColorSVG": "var(--mainColor)",

        // Check
        "--backgroundColorCheckSVG": "var(--highLight)",

        // Help/Info Buttons
        "--backgroundColorBtnSVG": "#fff",
        "--signColorBtnSVG": "var(--mainColor)",

        //Tooltip
        // "--tooltipSurface": ""
        "--tooltipText": "#fff",

        //Delegates
        "--ovaleBackgroundContributor": "var(--mainColor)",
        "--ovaleTextContributor": "#000",

        "--ovaleBackgroundNow": "var(--mainColor)",
        "--ovaleTextNow": "#000",

        "--ovaleBackgroundFuture": "#ba8a6a",
        "--ovaleTextFuture": "#ba8a6a",

        "--ovaleBackgroundNever": "#98abb6",
        "--ovaleTextNever": "#98abb6",

        "--footerBackground": "",
        "--textFooterBackground" : "#34274d",
    }
};

export const blueTheme: Theme = {
    name: "blueTheme",
    theme: 'white-label',
    properties: {

        // Main, Scd and Third variables are usually for titles and texts.
        "--mainColor": "#212121",
        "--scdColor": "#212121",
        "--thirdColor": "#212121",

        "--textColor": "#212121",

        // onSurface variable is for the colors on the surface of the app: grey boxes, side bar etc.
        "--onSurface": "#e3f2fd",

        // Title Sections
        "--titleSection": "#212121",

        // Breadcrumbs
        "--breadcrumbs": "#00000",

        // Highlighted Items
        "--highLight": "#e3f2fd",
        "--highLightSideNav": "#fff",
        "--highLightLabelSideNav": "#e3f2fd",
        "--textHoverLabelSideNav": "#fff",
        "--textLabelSideNav":"#fff",
        "--activeLabelSideNav":"#e3f2fd",
        "--activeTextLabelSideNav":"#fff",

        // Buttons
        "--defaultBtn": "#1976d2",
        "--hoverBtn": "#1565c0",
        "--attachmentBtn":"#212121",

        // Labels
        "--ovale": "#1976d2",
        "--textOvale":"#fff",
        "--label": "#1976d2",
        "--labelSideNav": "#1976d2",
        "--ovalePlanReview": "#1976d2",
        "--textLabel": "#fff",

        // Financial Bars
        "--financialFirstBar": "#1976d2",
        "--financialScdBar": "#1565c0",

        // SVGs
        // Global
        "--backgroundColorSVG": "var(--onSurface)",
        "--signColorSVG": "#fff",

        // Check
        "--backgroundColorCheckSVG": "#e3f2fd",

        // Help/Info Buttons
        "--backgroundColorBtnSVG": "#fff",
        "--signColorBtnSVG": "#1976d2",

        //Tooltip
        // "--tooltipSurface": ""
        "--tooltipText": "#fff"
    }
};

export const lifeFileTheme: Theme = {
    name: "lifeFile",
    theme: 'life-file',
    properties: {

        // Main, Scd and Third are usually for titles and texts.
        "--mainColor": "#FAB432",
        "--scdColor": "#000000",
        "--thirdColor": "#000000",

        "--textColor": "#000000",

        // onSurface is for the colors on the surface of the app: grey boxes, side bar etc.
        "--onSurface": "#fdebcb",

        // Title Sections
        "--titleSection": "#000000",

        // Breadcrumbs
        "--breadcrumbs": "#000000",

        // Highlighted Items
        "--highLight": "#fdebcb",
        "--highLightSideNav": "#fff",
        "--highLightLabelSideNav": "#355a9b",
        "--textHoverLabelSideNav": "#fff",
        "--textLabelSideNav":"#355a9b",
        "--activeLabelSideNav":"#355a9b",
        "--activeTextLabelSideNav":"#fff",

        // Buttons
        "--defaultBtn": "var(--mainColor)",
        "--hoverBtn": "#fdebcb",
        "--attachmentBtn":"#FAB432",

        // Labels
        "--ovale": "#FAB432",
        "--textOvale":"#000",
        "--label": "#1E3D71",
        "--labelSideNav": "#fff",
        "--ovalePlanReview": "#1E3D71",
        "--textLabel": "#fff",

        // Financial Bars
        "--financialFirstBar": "#98ABB6",
        "--financialScdBar": "var(--mainColor)",

        // SVGs
        // Global
        "--backgroundColorSVG": "var(--onSurface)",
        "--signColorSVG": "var(--mainColor)",

        // Check
        "--backgroundColorCheckSVG": "var(--highLight)",

        // Help/Info Buttons
        "--backgroundColorBtnSVG": "#fff",
        "--signColorBtnSVG": "var(--mainColor)",

        //Tooltip
        // "--tooltipSurface": ""
        "--tooltipText": "#000",

        //Delegates
        "--ovaleBackgroundContributor": "var(--mainColor)",
        "--ovaleTextContributor": "#000",

        "--ovaleBackgroundNow": "var(--mainColor)",
        "--ovaleTextNow": "#000",

        "--ovaleBackgroundFuture": "var(--mainColor)",
        "--ovaleTextFuture": "#000",

        "--ovaleBackgroundNever": "var(--mainColor)",
        "--ovaleTextNever": "#000",

        "--footerBackground": "",
        "--textFooterBackground" : "#000000",
    }
};

export const pemTheme: Theme = {
    name: "pemTheme",
    theme: 'pem',
    properties: {

        // Main, Scd and Third are usually for titles and texts.
        "--mainColor": "#b6daea",
        "--scdColor": "#000000",
        "--thirdColor": "#000000",

        "--textColor": "#000000",

        // onSurface is for the colors on the surface of the app: grey boxes, side bar etc.
        "--onSurface": "#b6daea",

        // Title Sections
        "--titleSection": "#000000",

        // Breadcrumbs
        "--breadcrumbs": "#000000",

        // Highlighted Items
        "--highLight": "#b6daea",
        "--highLightSideNav": "#fff",
        "--highLightLabelSideNav": "#355a9b",
        "--textHoverLabelSideNav": "#fff",
        "--textLabelSideNav":"#355a9b",
        "--activeLabelSideNav":"#0093D3",
        "--activeTextLabelSideNav":"#fff",

        // Buttons
        "--defaultBtn": "#0093D3",
        "--hoverBtn": "#b6daea",
        "--attachmentBtn":"#FAB432",

        // Labels
        "--ovale": "#0093D3",
        "--textOvale":"#000",
        "--label": "#0093D3",
        "--labelSideNav": "#fff",
        "--ovalePlanReview": "#0093D3",
        "--textLabel": "#fff",

        // Financial Bars
        "--financialFirstBar": "#98ABB6",
        "--financialScdBar": "var(--mainColor)",

        // SVGs
        // Global
        "--backgroundColorSVG": "var(--onSurface)",
        "--signColorSVG": "var(--scdColor)",

        // Check
        "--backgroundColorCheckSVG": "var(--highLight)",

        // Help/Info Buttons
        "--backgroundColorBtnSVG": "#fff",
        "--signColorBtnSVG": "var(--mainColor)",

        //Tooltip
        // "--tooltipSurface": ""
        "--tooltipText": "#000",

        //Delegates
        "--ovaleBackgroundContributor": "var(--mainColor)",
        "--ovaleTextContributor": "#000",

        "--ovaleBackgroundNow": "var(--mainColor)",
        "--ovaleTextNow": "#000",

        "--ovaleBackgroundFuture": "var(--mainColor)",
        "--ovaleTextFuture": "#000",

        "--ovaleBackgroundNever": "var(--mainColor)",
        "--ovaleTextNever": "#000",

        "--footerBackground": "#4A4A49",
        "--textFooterBackground" : "#fff",
    }
};

export const palmersTheme: Theme = {
    name: "palmersTheme",
    theme: 'palmers',
    properties: {

        // Main, Scd and Third are usually for titles and texts.
        "--mainColor": "#751A3F",
        "--scdColor": "#000000",
        "--thirdColor": "#000000",

        "--textColor": "#000000",

        // onSurface is for the colors on the surface of the app: grey boxes, side bar etc.
        "--onSurface": "#f2e9ec",

        // Title Sections
        "--titleSection": "#000000",

        // Breadcrumbs
        "--breadcrumbs": "#000000",

        // Highlighted Items
        "--highLight": "var(--mainColor)",
        "--highLightSideNav": "#fff",
        "--highLightLabelSideNav": "var(--mainColor)",
        "--textHoverLabelSideNav": "#fff",
        "--textLabelSideNav":"#355a9b",
        "--activeLabelSideNav":"var(--mainColor)",
        "--activeTextLabelSideNav":"#fff",

        // Buttons
        "--defaultBtn": "var(--mainColor)",
        "--hoverBtn": "var(--mainColor)",
        "--attachmentBtn":"var(--mainColor)",

        // Labels
        "--ovale": "var(--mainColor)",
        "--textOvale":"#000",
        "--label": "var(--mainColor)",
        "--labelSideNav": "#fff",
        "--ovalePlanReview": "var(--mainColor)",
        "--textLabel": "#fff",

        // Financial Bars
        "--financialFirstBar": "#98ABB6",
        "--financialScdBar": "var(--mainColor)",

        // SVGs
        // Global
        "--backgroundColorSVG": "var(--onSurface)",
        "--signColorSVG": "var(--scdColor)",

        // Check
        "--backgroundColorCheckSVG": "var(--highLight)",

        // Help/Info Buttons
        "--backgroundColorBtnSVG": "#fff",
        "--signColorBtnSVG": "var(--mainColor)",

        //Tooltip
        // "--tooltipSurface": ""
        "--tooltipText": "#000",

        //Delegates
        "--ovaleBackgroundContributor": "var(--mainColor)",
        "--ovaleTextContributor": "#000",

        "--ovaleBackgroundNow": "var(--mainColor)",
        "--ovaleTextNow": "#000",

        "--ovaleBackgroundFuture": "var(--mainColor)",
        "--ovaleTextFuture": "#000",

        "--ovaleBackgroundNever": "var(--mainColor)",
        "--ovaleTextNever": "#000",

        "--footerBackground": "#4A4A49",
        "--textFooterBackground" : "#fff",
    }
};

export const themeList = {
    default: defaultTheme,
    demo: blueTheme,
    lifeFile: lifeFileTheme,
    pemTheme: pemTheme,
    palmersTheme: palmersTheme
}


